import { ApplicableFilter, FilterItem } from '../../services/types/services'

export const getAutoAppliedFilters = ({
  selectedFilterIds,
  allFilters,
}: {
  selectedFilterIds: string[]
  allFilters: FilterItem[]
}): ApplicableFilter[] => {
  const isSelectableFilter = (item: ApplicableFilter) =>
    item.isSelected && !selectedFilterIds.includes(item.id)

  const collectSelected = (items: FilterItem[]): ApplicableFilter[] =>
    items.flatMap(item => {
      if (item.__typename === 'FilterHeader') {
        return []
      }
      if (item.__typename === 'FilterCategory' && item.children.length > 0) {
        return collectSelected(item.children)
      }
      return isSelectableFilter(item) ? [item] : /* istanbul ignore next */ []
    })

  return collectSelected(allFilters)
}
